import { FeatureFlag, Site } from '@ps/web-core-enums';
import { isUndefined } from 'lodash';
import React from 'react';
import { useSelector } from 'react-redux';

import Translation from '@swf/components/Translation/Translation';
import useFeature from '@swf/core/hooks/useFeature';
import { select } from '@swf/core/store';

import { ExclusionTime } from '../../shared/definitions';
import { ExclusionType } from '../definitions';
import useExclusionType from '../hooks/useExclusionType';

import {
  TXTWCL_Want_to_take_a_break_from_play_ELL,
  TXTWCL_XbXTake_a_break_from_playingX__ELL,
  TXTWCL_YouXre_self_excluded,
  TXTWCL_YouXre_self_excluded_Nationall_ELL,
  TXTWCL_YouXre_self_excluded_indefinit_ELL,
  TXTWCL_YouXre_taking_a_break,
  TXTWCL_YouXve_chosen_to_self_exclude__ELL,
  TXTWCL_You_are_permanently_self_exclu_ELL,
  TXTWCL_Your_Self_Exclusion_period_has_ELL
} from './ExclusionTitle.messages.json';

interface Props {
  daysRequested?: number;
  nationalSelfExclusionVegas?: boolean;
}

export const getExclusionTitle = (
  nationalExclusion: boolean,
  visibilityOASISExclusionOption: boolean,
  showVegasContent: boolean,
  site: Site,
  daysRequested?: number,
  exclusionType?: ExclusionType,
  nationalSelfExclusionVegas?: boolean
) => {
  const isSiteUK = site === Site.UK;

  switch (true) {
    case nationalSelfExclusionVegas:
    case nationalExclusion && showVegasContent && !visibilityOASISExclusionOption:
      return TXTWCL_YouXve_chosen_to_self_exclude__ELL;
    case nationalExclusion && visibilityOASISExclusionOption:
      return TXTWCL_YouXre_taking_a_break;
    case nationalExclusion:
      return TXTWCL_YouXre_self_excluded_Nationall_ELL;
    case !isUndefined(daysRequested) && isSiteUK && daysRequested === ExclusionTime.Indefinite:
      return TXTWCL_You_are_permanently_self_exclu_ELL;
    case !isUndefined(daysRequested) &&
      site === Site.USPA &&
      daysRequested === ExclusionTime.Indefinite:
      return TXTWCL_YouXre_self_excluded_indefinit_ELL;
    case !isUndefined(daysRequested) && isSiteUK:
      return TXTWCL_Your_Self_Exclusion_period_has_ELL;
    case !isUndefined(daysRequested) &&
      ![Site.FR, Site.GR, Site.PT].includes(site) &&
      exclusionType === ExclusionType.SelfExclusion:
      return TXTWCL_YouXre_self_excluded;
    case !isUndefined(daysRequested):
      return TXTWCL_YouXre_taking_a_break;
    case visibilityOASISExclusionOption ||
      [Site.FR, Site.GR, Site.USPA, Site.USNJ, Site.PT].includes(site):
      return TXTWCL_XbXTake_a_break_from_playingX__ELL;
    default:
      return TXTWCL_Want_to_take_a_break_from_play_ELL;
  }
};

const ExclusionTitle: React.FC<Props> = ({ daysRequested, nationalSelfExclusionVegas }) => {
  const site = useSelector(select.cms.getSiteId);
  const showVegasContent = useSelector(select.cms.showVegasContent);
  const nationalExclusion = useSelector(select.account.bannedByRegulator);
  const exclusionType = useExclusionType(daysRequested, nationalExclusion);
  const visibilityOASISExclusionOption = useFeature(FeatureFlag.VisibilityOASISExclusionOption);

  return (
    <Translation
      {...getExclusionTitle(
        nationalExclusion,
        visibilityOASISExclusionOption,
        showVegasContent,
        site,
        daysRequested,
        exclusionType,
        nationalSelfExclusionVegas
      )}
    />
  );
};

export default ExclusionTitle;
